import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { feature: t('comparison.row1_feature'), usfans: t('comparison.row1_usfans'), alt: t('comparison.row1_alt') },
    { feature: t('comparison.row2_feature'), usfans: t('comparison.row2_usfans'), alt: t('comparison.row2_alt') },
    { feature: t('comparison.row3_feature'), usfans: t('comparison.row3_usfans'), alt: t('comparison.row3_alt') },
    { feature: t('comparison.row4_feature'), usfans: t('comparison.row4_usfans'), alt: t('comparison.row4_alt') },
    { feature: t('comparison.row5_feature'), usfans: t('comparison.row5_usfans'), alt: t('comparison.row5_alt') },
    { feature: t('comparison.row6_feature'), usfans: t('comparison.row6_usfans'), alt: t('comparison.row6_alt') },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('comparison.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">{t('comparison.subtitle')}</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-accent-100/50">
                  <th className="text-left px-6 py-4 font-heading font-semibold text-foreground-900 whitespace-nowrap">{t('comparison.col_feature')}</th>
                  <th className="text-left px-6 py-4 font-heading font-semibold text-accent-700 whitespace-nowrap">
                    <span className="flex items-center gap-2">
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-checkbox-circle-fill text-accent-500"></i>
                      </span>
                      {t('comparison.col_usfans')}
                    </span>
                  </th>
                  <th className="text-left px-6 py-4 font-heading font-semibold text-foreground-500 whitespace-nowrap">{t('comparison.col_alternatives')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/60'}>
                    <td className="px-6 py-4 font-medium text-foreground-700 whitespace-nowrap">{row.feature}</td>
                    <td className="px-6 py-4 text-accent-700 font-semibold whitespace-nowrap">{row.usfans}</td>
                    <td className="px-6 py-4 text-foreground-500 whitespace-nowrap">{row.alt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap"
          >
            {t('cta.go_to_main')}
            <span className="w-4 h-4 flex items-center justify-center ml-2">
              <i className="ri-external-link-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}